import * as actions from '../ActionType/UserActionType';
const initExercise = {
    allCustomer:[],
    customerCreate:[],
    customerDelete:[],
    getCustomersById:[],
    sendInvite:[],
    infoUpdateCustomer:[],
    status:[],
    uploadData:[],
    allDocuments:[],
    downloadDocuments:[],
    deleteClientCustomer:[],
    usersPermission:[],
    groupUsersPermission:[],
    usersDeletePermission:[],
    groupUsersDeletePermission:[],
    documentUpdate:[]
}
export const CustomerReducer = (state = initExercise, action:any) => {
    switch (action.type) {
        case actions.CUSTOMER_ALL: 
            return{
                ...state,
                allCustomers:action.payload
            };
        case actions.CUSTOMER_CREATE: 
            return{
                ...state,
               customerCreate:action.payload
            };
        case actions.CUSTOMER_DELETE: 
            return{
                ...state,
               customerDelete:action.payload
            };
        case actions.CUSTOMER_GET: 
            return{
                ...state,
                getCustomersById:action.payload
            };
        case actions.CUSTOMER_INVITATION: 
            return{
                ...state,
                sendInvite:action.payload
            };
         case actions.DOCUMENT_UPLOAD: 
            return{
                ...state,
                uploadData:action.payload
            };
        case actions.CUSTOMER_INFO_UPDATE: 
            return{
                ...state,
                infoUpdateCustomer:action.payload
            };
            case actions.CUSTOMER: 
            return{
                ...state,
                status:action.payload
            };
            case actions.ALL_DOCUMENT: 
            return{
                ...state,
                allDocuments:action.payload
            };
            case actions.DOWNLOAD_DOCUMENT: 
            return{
                ...state,
                downloadDocuments:action.payload
            };
            case actions.CLIENT_ADMIN_CUSTOMER:
                return{
                    ...state,
                    deleteClientCustomer:action.payload
                };
            case actions.PERMISSION_USER:
                return{
                    ...state,
                    usersPermission:action.payload
                };
            case actions.GROUP_USER_PERMISSION:
                 return{
                        ...state,
                    groupUsersPermission:action.payload
                };
            case actions.DOCUMENT_FILE_UPDATE:
                 return{
                        ...state,
                    documentUpdate:action.payload
                };
            case actions.DELETE_HARD:
            return{
                   ...state,
                   hardDelete:action.payload
            }
                
    default:
         return state;
    }
}